import commentService from 'resources/comment/comment.service';
import documentService from 'resources/document/document.service';
import * as storageService from 'services/storage.service';

export const deleteDocument = async (id) => {
  const document = await documentService.findById(id);

  if (!document) {
    return;
  }

  const documentBucket = document.file_url.substr(0, document.file_url.indexOf('/'));
  const documentPath = document.file_url.substring(document.file_url.indexOf('/') + 1);
  const documentCommentsToResolve = await commentService.getDocumentAuditCommentsToResolve(id);

  // First, delete the document record
  const documentResponse = await documentService.remove({ id });

  // If document deletion is successful, proceed with file deletion
  if (!documentResponse.error) {
    await storageService.removeFile({
      bucket: documentBucket,
      path: documentPath,
    });

    // Resolve comments
    if (documentCommentsToResolve) {
      await commentService.resolveAuditComments({ documentId: id });
    }
  }

  return id;
};
